import $ from "jquery";
// import Swiper JS
import Swiper from 'swiper';
// import Swiper styles
import 'swiper/swiper-bundle.css';


if ($('.featured-vlogs-wrapper').length){
    // configure Swiper to use modules

    new Swiper('.featured-vlogs-wrapper', {
        direction: 'horizontal',
        // loop: false, 
        // spaceBetween: 20,
        breakpoints: {
            300: {
                slidesPerView: 1.5,
            },
            570: {
                slidesPerView: 1.5,
            },
            768: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: 4,
            }
        },
    });
}